import moment from 'moment'
import React, {
  useEffect,
  useState,
} from 'react'
import { connect } from 'react-redux'
import {
  useHistory,
  withRouter,
} from 'react-router-dom'
import api, { getSummaryInfoForJob } from '../../api'
import BaseTable from '../../components/BaseTable'
import DatePickerReports from '../../components/DatePickerReports'
import DateTimePicker from '../../components/DateTimePicker'
import EmployeesList from '../../components/EmployeesList'
import FinalRunJobPage from '../../components/FinalRun/FinalRunJobPage'
import InventoryBlock from '../../components/InventoryBlock'
import JobDetails from '../../components/JobDetails'
import EmployeeInfoModal from '../../components/JobDetails/EmployeeInfoModal'
import JobEmployeesBlock from '../../components/JobEmployeesBlock'
import MainHeader from '../../components/MainHeader'
import MainView from '../../components/MainView'
import ScanBarcodeBlock from '../../components/ScanBarcodeBlock'
import VarianceTitle from '../../components/VarianceBlock/VarianceTitle'
import useFetchAll from '../../hooks/useFetchAll'

import {
  fetchDealers,
  fetchJobById,
  fetchJobs,
  getOrders,
  redirectToVariance,
  updateJob,
} from '../../store/actions'
import { toApiDate } from '../../utils/dateHelper'
import { sortText } from '../../utils/sortHelper'
import './index.css'


const JobInfo = (props) => {
  useFetchAll(
    { condition: !props.jobList.length, action: props.fetchJobs },
    { condition: !props.dealerList.length, action: props.fetchDealers },
  )
  const [job, setJob] = useState(null)
  const [isShowDateTimePicker, setIsShowDateTimePicker] = useState(false)
  const [isEmployeeInfoModalOpen, setIsEmployeeInfoModalOpen] = useState(null)
  const [searchTerm, setSearchTerm] = useState({ type: 'user', value: 'whole team' })
  const [searchedInventory, setSearchedInventory] = useState([])
  const jobId = props.location.pathname.split('/')[2]
  const [orders, setOrder] = useState('')
  const [lastOrder, setLastOrder] = useState('')
  const [ordersSort, setOrdersSort] = useState({ isDesc: false, prop: '' })
  const [showDataPickerJobsReports, setShowDataPickerJobsReports] = useState(false)

  const sortTable = ({ dataKey }) => {
    setOrdersSort({
      isDesc: ordersSort.prop === dataKey ? !ordersSort.isDesc : false,
      prop: dataKey,
    })
  }

  let history = useHistory()
  const convertSummaryInfo = (data) => {
    return data.data.map((data) => {
      return {
        ...data,
        countingMode: data.countingMode === 'bin_centric' ? 'Bin' : 'Part',
      }
    })
  }

  const toggleDatePickerJobReports = () => {
    setShowDataPickerJobsReports(!showDataPickerJobsReports)
  }

  const onClickCounting = (e) => {
    e.preventDefault()
  }
  const onClickVariance = (e) => {
    e.preventDefault()
  }

  const onClickRedirectToVariance = async () => {
    await props.redirectToVariance(true)
    await history.push(`/jobs/${job.UUID}/variance`)
  }

  useEffect(() => {
    const { prop, isDesc } = ordersSort
    const sorted = [...orders].sort(sortText(prop, isDesc))
    setOrder(sorted)
  }, [ordersSort])

  useEffect(() => {
    (async () => {
      const { data } = await getSummaryInfoForJob(jobId)
      const orders = await convertSummaryInfo(data)
      setOrder(orders)
      setLastOrder({ ...orders[orders.length - 1] })
      await props.getOrders(orders)

    })()
  }, [])

  const tableOptions = {
    columns: [{
      name: 'Order Run',
      type: 'order-run',
      isSortable: true,
      dataKey: 'runOrder',
      cellPadding: '3rem',
    },
    {
      name: 'Status',
      type: 'text',
      isSortable: true,
      dataKey: 'status',
    },
    {
      name: 'Bin/Part Centric',
      type: 'text',
      isSortable: true,
      dataKey: 'countingMode',
    },
    {
      name: 'Total Parts',
      type: 'text',
      isSortable: true,
      dataKey: 'partsCount',
      flexGrow: 'fg100-c',
    },
    {
      name: 'Inventory Value',
      type: 'text',
      isSortable: true,
      dataKey: 'inventoryValue',
      flexGrow: 'fg100-c',
    },
    ],
  }
  useEffect(() => {
    if (!props.jobList.length) {
      return
    }
    const job = props.jobList.find(job => props.match.params.jobId === job.UUID)
    if (!job) {
      props.fetchJobById(props.match.params.jobId)
      return
    }
    setJob(job)
  }, [props.jobList])

  const choseDate = async ({ date, time }) => {
    await props.updateJob({
      scheduledStartTime: toApiDate(date + ' ' + time),
      name: job.name,
      dealerUUID: job.dealerUUID,
    }, job.UUID)
    toggleDateTimePicker()
  }
  const toggleDateTimePicker = () => setIsShowDateTimePicker(!isShowDateTimePicker)

  const toggleEmployeeModal = (employee) => {
    if (employee) {
      setIsEmployeeInfoModalOpen({ employee })
    } else {
      setIsEmployeeInfoModalOpen(!isEmployeeInfoModalOpen)
    }
  }



  useEffect(() => {
    const { type, value } = searchTerm
    if (type === 'user' && value === 'whole team') {
      return setSearchedInventory([])
    }
    if (type === 'text') {
      api.searchCountingResultByTerm(job.UUID, value).then(res => {
        setSearchedInventory(res.data.data)
      })
    } else if (type === 'user') {
      api.searchCountingResultByUser(job.UUID, value).then(res => {
        setSearchedInventory(res.data.data)
      })
    }
  }, [searchTerm])



  return (
    <div>
      <MainHeader title={job ? job.name : ''} backLink="/jobs" />
      <MainView>
        {job &&
          <div className="job-info">
            <div className="job-info__left-bar">
              <>
                <JobDetails
                  job={job}
                  status={job.status}
                  toggleDateTimePicker={toggleDateTimePicker}
                />
                {(job.status === 'scheduled' || job.status === 'in progress') &&
                  <ScanBarcodeBlock />}
              </>
            </div>
            <div className="job-info__right-bar-parent">
              <div className='job-info__right-bar'>
                {job.status === 'scheduled' &&
                  <JobEmployeesBlock jobId={job.UUID} toggleEmployeeModal={toggleEmployeeModal} />}
                {job.status !== 'scheduled' &&
                  <>
                    {orders.length >= 1 ? <div className="orders-list">
                      <InventoryBlock
                        job={job}
                        status={job.status}
                        searchTerm={searchTerm}
                        setSearchTerm={setSearchTerm}
                        searchedInventory={searchedInventory}
                        lastOrder={lastOrder}
                        orders={orders}
                      />
                      <VarianceTitle />
                      <BaseTable
                        keyProp="id"
                        onSort={sortTable}
                        options={tableOptions}
                        data={orders}
                        padding={'0rem'}
                        rowSelectable={true}
                        disable={true}
                      />
                      {lastOrder.status === 'completed' && lastOrder.type && (
                        <FinalRunJobPage job={job} lastOrder={lastOrder} jobPage={true} onClickRedirectToVariance={onClickRedirectToVariance} orders={orders} />)}
                    </div> : <InventoryBlock
                      job={job}
                      status={job.status}
                      searchTerm={searchTerm}
                      setSearchTerm={setSearchTerm}
                      searchedInventory={searchedInventory}
                      lastOrder={lastOrder}
                      orders={orders}
                    />}
                    <EmployeesList
                      job={job}
                      searchTerm={searchTerm.type === 'user' ? searchTerm.value : null}
                      setSearchTerm={setSearchTerm}
                      toggleEmployeeModal={toggleEmployeeModal}
                    />
                  </>
                }
              </div>
            </div>
          </div>
        }
      </MainView>
      {isShowDateTimePicker &&
        <DateTimePicker
          date={moment(job.scheduledStartTime, 'YYYY-MM-DD h:mm')}
          time={moment(job.scheduledStartTime.split(' ')[1], 'h:mm')}
          onChoseDate={choseDate} closeDateTimePicker={() => toggleDateTimePicker()}
        />
      }
      {
        isEmployeeInfoModalOpen &&
        <EmployeeInfoModal
          employee={isEmployeeInfoModalOpen.employee}
          onClose={() => toggleEmployeeModal(null)}
        />
      }
      {
        showDataPickerJobsReports &&
        <DatePickerReports />
      }

    </div>
  )
}

const mapStateToProps = (
  {
    jobs: {
      jobList,
    }
    ,
    data: {
      newRun, redirect,
    }
    ,
    dealers: {
      dealerList, shortDealerList,
    }
    ,
    reports: {
      reports,
      showDatePickerReports,
    }
    ,
  }
  ,
) => (
  {
    jobList,
    dealerList,
    shortDealerList,

    newRun,
    redirect,

    reports,
    showDatePickerReports,

  }
)
const mapDispatchToProps =
{
  fetchJobs, fetchDealers, updateJob, fetchJobById, redirectToVariance,
  getOrders,
}

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(JobInfo))
